module.exports = __webpack_public_path__ + "img/tj-light-bg-mask.de39743b.png";